const TRANSLATIONS_EN = {
    saveFailed: 'Save failed. Click to retry.'
};

export default TRANSLATIONS_EN;
